import {
  DataQueryKey,
  UseDataQuery,
  UseDataQueryKey,
} from '../../../hooks/useDataQuery/dataQuery.types';
import { GetProductDetailsProductColor } from '../../../modules/orders/products/interfaces/get-order-product-grid.interface';
import {
  IProductDetailsFilterParams,
  IProductDetailsGridParams,
  IProductDetailsGroupSectionParams,
  ProductDetailsFiltersParams,
  ProductDetailsMediasParams,
} from './productDetails.types';

export const getProductDetailsCombinationGridKey = (
  params: IProductDetailsGridParams | ProductDetailsFiltersParams,
): UseDataQuery['queryKey'] => [DataQueryKey.PRODUCT_DETAILS_COMBINATIONS, undefined, params ?? {}];

export const getProductDetailsCountGridKey = (
  params: IProductDetailsGridParams | ProductDetailsFiltersParams,
): UseDataQuery['queryKey'] => [DataQueryKey.PRODUCT_DETAILS_COUNT, undefined, params ?? {}];

export const getProductDetailsEmptyAvailabilitiesKey = (
  params: Pick<ProductDetailsFiltersParams, 'productId' | 'orderId'>,
): UseDataQuery['queryKey'] => [
  DataQueryKey.PRODUCT_DETAILS_EMPTY_AVAILABILITIES,
  params.productId,
  {
    orderId: params.orderId,
  },
];

export const getProductDetailsProductColorKey = (
  params: GetProductDetailsProductColor,
): UseDataQueryKey => [
  DataQueryKey.PRODUCT_DETAILS_PRODUCT_COLOR,
  params.productColorId,
  {
    isAdminSeller: params.isAdminSeller,
    orderId: params.orderId,
  },
];

export const getProductDetailsFilterKey = (
  params: IProductDetailsFilterParams,
): UseDataQueryKey => [
  DataQueryKey.PRODUCT_DETAILS_FILTER,
  params.productId,
  {
    availability: params.availability,
    productColorId: params.productColorId,
    orderIds: params.orderIds,
    filterByRelatedProducts: params.filterByRelatedProducts,
  },
];

export const getProductDetailsMediasKey = (params: ProductDetailsMediasParams): UseDataQueryKey => [
  'product-details-medias',
  params.productId,
  {},
];

export const getProductDetailsSizesKey = (params: ProductDetailsFiltersParams): UseDataQueryKey => [
  DataQueryKey.PRODUCT_DETAILS_SIZES,
  params.productId,
  {
    orderId: params.orderId,
  },
];

export const getProductDetailsSummaryKey = (
  params: IProductDetailsGroupSectionParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.PRODUCT_DETAILS_SUMMARY,
  params.orderId,
  {
    ...params,
  },
];

export const getCombinationsValidationKey = (
  params: IProductDetailsGridParams | ProductDetailsFiltersParams,
): UseDataQueryKey => [
  DataQueryKey.PRODUCT_DETAILS_COMBINATIONS_VALIDATION,
  undefined,
  params ?? {},
];
